import { Box, Flex, Progress } from '@mantine/core'

import type { RangeBarChartProps } from '@/components/RangeBarChart/RangeBarChart.types'
import { Text } from '@/components/Text/Text'

export function RangeBarChart({ color, sections }: RangeBarChartProps) {
  const counts = Object.values(sections).map(count => Number(count))
  const total = counts.reduce((sum, count) => sum + count, 0)

  return Object.keys(sections).map(section => {
    const percentageValue = total ? (sections[section] / total) * 100 : 0

    return (
      <Box key={section} mt={16}>
        <Progress
          key={section}
          color={color}
          mb={8}
          radius="xl"
          size="lg"
          value={percentageValue}
        />

        <Flex align="center">
          <Text variant="body_2_black">{section}</Text>
          <Text ml="auto" variant="body_2_semibold_black">
            {percentageValue.toFixed(0)}%
          </Text>
        </Flex>
      </Box>
    )
  })
}
